import { useEffect, useState } from "react";

const ToggleButton = ({ label, onChange, id, checked, color: c }) => {
  const [style, setStyle] = useState(
    "btn btn-sm btn-outline btn-primary rounded-3xl"
  );
  const [color, setColor] = useState(c || "primary");

  const handleChange = (e) => {
    onChange && onChange(e);
    if (e.target.checked) {
      setStyle(`btn btn-sm rounded-3xl btn-${color}`);
    } else {
      setStyle(`btn btn-sm rounded-3xl btn-outline btn-${color}`);
    }
  };

  useEffect(() => {
    if (color !== c) setColor(color);
    if (checked) {
      setStyle(`btn btn-sm rounded-3xl btn-${color}`);
    } else {
      setStyle(`btn btn-sm rounded-3xl btn-outline btn-${color}`);
    }
  }, [checked, c, color]);
  return (
    <label className={style}>
      <input
        type="checkbox"
        className="appearance-none"
        id={id}
        onChange={handleChange}
        checked={checked}
      />
      {label}
    </label>
  );
};

export default ToggleButton;
